import React from "react";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";

export default function ENHome() {
  return (
    <>
      <Navbar isEnglish={true} />
      
      <section className="hero">
        <div className="container hero-content">
          <div className="hero-text">
            <h1>Real-Time Multilingual Speech Translation</h1>
            <p>
              Capture live speech, instantly translate it into multiple languages, and broadcast it as text or audio to attendees anywhere in the world.
            </p>
            <div className="cta-buttons">
              <a href="#demo" className="cta primary">Book a Demo</a>
              <a href="#trial" className="cta secondary">Try Now</a>
            </div>
          </div>
          <div className="hero-image">
            <img 
              src="https://via.placeholder.com/500x350" 
              alt="TercumanApp live translation application" 
            />
          </div>
        </div>
      </section>
      
      <section id="how-it-works">
        <div className="container">
          <div className="section-header">
            <h2>How It Works</h2>
            <p>TercumanApp simplifies the multilingual real-time translation process for your events</p>
          </div>
          
          <div className="steps">
            <div className="step-item">
              <div className="step-number">1</div>
              <h3>Stream</h3>
              <p>Technician streams live audio from the event using a web-based control panel</p>
            </div>
            
            <div className="step-item">
              <div className="step-number">2</div>
              <h3>Process</h3>
              <p>Our backend transcribes, detects language, translates, and synthesizes speech</p>
            </div>
            
            <div className="step-item">
              <div className="step-number">3</div>
              <h3>Access</h3>
              <p>Attendees receive real-time transcriptions and audio in their preferred language</p>
            </div>
          </div>
        </div>
      </section>
      
      <section id="features">
        <div className="container">
          <div className="section-header">
            <h2>Key Features</h2>
            <p>Cutting-edge features powered by modern technology to transform your events</p>
          </div>
          
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🎤</div>
              <h3>Continuous Speech Recognition</h3>
              <p>Real-time speech recognition and language identification technology</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🌍</div>
              <h3>Multiple Languages</h3>
              <p>Instantly translate speech into multiple languages simultaneously</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🔊</div>
              <h3>Speech Synthesis</h3>
              <p>Listen to translations as natural voice narration</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🔒</div>
              <h3>Secure Access</h3>
              <p>Session codes ensure secure attendee access to your event</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">⚙️</div>
              <h3>Easy Management</h3>
              <p>Web-based technician control panel for seamless operation</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>Scalable Solution</h3>
              <p>Capacity to serve thousands of attendees simultaneously</p>
            </div>
          </div>
        </div>
      </section>
      
      <section id="use-cases" className="use-cases">
        <div className="container">
          <div className="section-header">
            <h2>Use Cases</h2>
            <p>Discover how TercumanApp adds value across different scenarios</p>
          </div>
          
          <div className="use-cases-grid">
            <div className="use-case-card">
              <h3>Corporate Events</h3>
              <p>Global meetings and events for multinational companies</p>
            </div>
            
            <div className="use-case-card">
              <h3>International Conferences</h3>
              <p>Scientific and academic conferences with participants from different countries</p>
            </div>
            
            <div className="use-case-card">
              <h3>Live Broadcasts</h3>
              <p>Instant translation for live broadcast panels and discussions</p>
            </div>
            
            <div className="use-case-card">
              <h3>Religious Services</h3>
              <p>Translation of services and talks for congregations speaking different languages</p>
            </div>
            
            <div className="use-case-card">
              <h3>Government & NGO Meetings</h3>
              <p>Multilingual meetings for government institutions and non-governmental organizations</p>
            </div>
          </div>
        </div>
      </section>
      
      <section id="testimonials">
        <div className="container">
          <div className="section-header">
            <h2>Testimonials</h2>
            <p>What users are saying about TercumanApp</p>
          </div>
          
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <p className="quote">"TercumanApp has made managing our multilingual conferences easier and significantly increased attendee satisfaction."</p>
              <div className="author">
                <div className="author-avatar"></div>
                <div>
                  <div className="author-name">Jessica Chen</div>
                  <div className="author-title">Event Coordinator, GlobeConf</div>
                </div>
              </div>
            </div>
            
            <div className="testimonial-card">
              <p className="quote">"With its Azure infrastructure and real-time translation capabilities, communication with our international clients has never been easier."</p>
              <div className="author">
                <div className="author-avatar"></div>
                <div>
                  <div className="author-name">Michael Rodriguez</div>
                  <div className="author-title">CTO, TechGlobal Inc.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section className="cta-section">
        <div className="container">
          <h2>Ready to Globalize Your Events?</h2>
          <p>Break language barriers and reach the entire world with TercumanApp.</p>
          <div className="cta-buttons">
            <a href="#demo" className="cta primary">Book a Demo</a>
            <a href="#contact" className="cta secondary">Contact Us</a>
          </div>
        </div>
      </section>
      
      <section id="contact">
        <div className="container">
          <div className="section-header">
            <h2>Contact</h2>
            <p>Reach out to us with your questions</p>
          </div>
          
          <div className="contact-details">
            <div className="contact-info">
              <div className="contact-item">
                <div className="contact-icon">📧</div>
                <h3>Email</h3>
                <p><a href="mailto:info@tercuman.app">info@tercuman.app</a></p>
              </div>
              
              <div className="contact-item">
                <div className="contact-icon">📍</div>
                <h3>Address</h3>
                <p>Istanbul, Turkey</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
